import { render } from "./doubleInput.vue?vue&type=template&id=1b27063c&lang=pug"
import script from "./doubleInput.vue?vue&type=script&lang=js"
export * from "./doubleInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/doubleInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b27063c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b27063c', __exports__)) {
    api.reload('1b27063c', __exports__)
  }
  
  module.hot.accept("./doubleInput.vue?vue&type=template&id=1b27063c&lang=pug", () => {
    api.rerender('1b27063c', render)
  })

}


export default __exports__